module.exports = __webpack_public_path__ + "a4066243741425b50cd801062bbd2b66.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-22.png
// module id = 115
// module chunks = 0